import React from 'react';
import Icon from "./Icon";
import PropTypes from "prop-types";

const TwitterIcon = (props) => {
    return (
        <div className='listing-footer__icon-block' onClick={props.onClick}>
            <Icon
                className='text-white'
                icon='icon-twitter'
                selected={props.selected}
            />
        </div>
    );
}

TwitterIcon.propTypes = {
    selected: PropTypes.bool,
    onClick: PropTypes.func,
}

TwitterIcon.defaultProps = {
    selected: false,
    onClick: () => {}
}

export default TwitterIcon;
